import dayjs from "dayjs";
import MultiQtyCell from "../../components/dms_common/MultiQtyCell";
import { GridRenderCellParams } from "@mui/x-data-grid";
import PrimaryReturnQtyCell from "../viewPrimaryReturn/PrimaryReturnQtyCell";
import { Link, Tooltip } from "@mui/material";
export const PrimaryOrderConfigV2 = {
  columns: [
    { headerName: "Order Reference No.", mappedValue: "orderNumber", width: 170, headerAlign: "left", align: "left" },
    {
      headerName: "Order Date & Time",
      mappedValue: "creationTime",
      width: 170,
      headerAlign: "left",
      align: "left",
      renderCell: (params: any) => dayjs(params.value).format("DD-MM-YYYY HH:mm:ss"), 
      sortKey: "creationTime",
      sortType: "date"
    },
    { headerName: "Quantity", mappedValue: "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity", width: 120, headerAlign: "left", align: "left", 
      type: "viewprimaryorderconfigs", 
      sortKey: "normalizedQuantity",
      sortType: "number"
    },
    { headerName: "Amount", mappedValue: "netAmount", width: 120, headerAlign: "left", align: "left",
      sortKey: "netAmount",
      sortType: "number"
     },
    { headerName: "Order Status", mappedValue: "status", width: 170, headerAlign: "left", align: "left" },
    { headerName: "GRN Status(if any)", mappedValue: " ", width: 170, headerAlign: "left", align: "left" },
  ],
  Actions: ["view", "download"],
};

export const PrimaryOrderConfig = {
  columns: [
    { headerName: "Order Reference No.", mappedValue: "orderNumber", width: 170, headerAlign: "left", align: "left" },
    {
      headerName: "Order Date & Time",
      mappedValue: "creationTime",
      width: 170,
      headerAlign: "left",
      align: "left",
      renderCell: (params: any) => dayjs(params.value).format("DD-MM-YYYY HH:mm:ss"), 
    },
    { headerName: "Quantity", mappedValue: "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity", width: 120, headerAlign: "left", align: "left", 
      type: "viewprimaryorderconfigs", 
    },
    { headerName: "Amount", mappedValue: "netAmount", width: 120, headerAlign: "left", align: "left",
      sortType: "number"
     },
    { headerName: "Order Status", mappedValue: "status", width: 170, headerAlign: "left", align: "left" },
    { headerName: "GRN Status(if any)", mappedValue: " ", width: 170, headerAlign: "left", align: "left" },
  ],
  Actions: ["view", "download"],
};



export const PrimaryReturnConfig = () => {

  const ConfigDictionary = JSON.parse( localStorage.getItem("ConfigDictionary") ?? "{}");
  const primaryReturnApproval = ConfigDictionary.primaryReturnApproval ?? true;
  const columns = [
    {
      headerName: "Return Order No.",
      mappedValue: "returnInvoiceNumber",
      width: 170,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Invoice No.",
      mappedValue: "invoiceNumber",
      width: 120,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "GRN No.",
      mappedValue: "grnNumber",
      width: 120,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Return Date",
      mappedValue: "returnDate",
      width: 130,
      headerAlign: "left",
      align: "left",
      renderCell: (params: any) => dayjs(params.value).format("DD-MM-YYYY"),
      truncateText: true,
      sortKey: 'returnDate',
      sortType: 'date',
    },
    {
      headerName: "Approval Date",
      mappedValue: "approvalDate",
      width: 130,
      headerAlign: "center",
      align: "center",
      renderCell: (params: any) => dayjs(params.value).format("DD-MM-YYYY"),
      truncateText: true,
      sortKey: 'returnDate',
      sortType: 'date',
    },
    {
      headerName: "Return Quantity",
      mappedValue: "returnCaseQuantity,returnPieceQuantity,returnOtherUnitQuantity",
      width: 170,
      headerAlign: "left",
      align: "left",
      cellRenderElement: (params: GridRenderCellParams) => {
        return (
          <PrimaryReturnQtyCell
            csQty={params.row.returnCaseQuantity}
            pcQty={params.row.returnPieceQuantity}
            otherQty={params.row.returnOtherUnitQuantity}
          />
        )
      },
      sortKey: 'normalizedQuantity',
      sortType: 'number',
    },
    {
      headerName: "Return Value",
      mappedValue: "returnValue",
      width: 120,
      headerAlign: "left",
      align: "left",
      amountDisplay: true,
      truncateText: true,
      sortKey: 'returnValue',
      sortType: 'number',
    },
    {
      headerName: "Status",
      mappedValue: "status",
      width: 130,
      headerAlign: "center",
      align: "center",
      truncateText: true,
    },
  ];

  const filteredColumns = primaryReturnApproval
    ? columns
    : columns.filter(
        (col) => !["Approval Date", "Status"].includes(col.headerName)
      );

  return {
    columns: filteredColumns,
    Actions: ["view"],
  };
};


export type PrimaryReturnRows = {
  id:string
  returnInvoiceNumber: string,
  invoiceNumber: string,
  grnNumber: string,
  returnDate: string,
  approvalDate: string,
  returnCaseQuantity: number,
  returnPieceQuantity: number,
  returnOtherUnitQuantity: number,
  returnValue: string,
  status: string,
  showEyeIcon: boolean,
  normalizedQuantity: number,
}

